import { Typography } from "@mui/material";
import noResultImg from "../assets/no-result.webp";

export default function NoResult(props: { title?: string }) {
  return (
    <div className="all-center-wrapper width-100p column-wrapper">
      <img width={200} src={noResultImg} alt="no result" />
      <Typography variant="body1">{props.title || "No Result"}</Typography>
    </div>
  );
}
